import React, { useEffect, useState } from "react";
import styles from "./CouncilCalendarCard.module.scss";
import InfoButton from "../../Atoms/InfoButton/InfoButton";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import { useNavigate } from "react-router-dom";
import DeletePopup from "../Custom/DeletePopup";
import { useDeleteNews } from "../../../Hooks/News";
import newsUpdated from "../../../assets/Imagess/news-updated.png";
import CouncilCalendarInfoModal from "./CouncilCalendarInfoModal";
import { useToast } from "../Custom/CustomToaster/Toast";

function CouncilCalendarCard({ calendar, refetch }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const customizedToast = useToast();
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const {
    mutate: deleteNews,
    isLoading: isDeletingNews,
    isSuccess,
  } = useDeleteNews(calendar?.newsId);

  useEffect(() => {
    setIsActive(calendar?.isActive);
  }, [calendar]);

  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-council-calendar/${calendar?.councilCalendarId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    refetch();
  }, [isDeletingNews]);

  useEffect(() => {
    if (isSuccess) {
      // setShowCheckmark(true);
      customizedToast.open('تم الحذف بنجاح');
      setTimeout(() => {
        setShowCheckmark(false);
      }, 2000);
    }
  }, [isSuccess]);

  return (
    <div className={styles['news-card']}>
      <div className={styles['news-card-info']}>
        <div className={styles['row']}>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
          />
        </div>
        <div className={styles['row']}>
          <div
            className={styles['title-container']}
            onClick={() => setShowInfo(true)}
          >
            <p className={styles['title-top']}>Academic Year</p>
            <p className={styles['sub-title']}>
              {calendar?.academicYear?.academicName}
            </p>
          </div>
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="التقويم"
          handleDelete={() => {
            deleteNews();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingNews}
        />
      )}
      {showInfo && (
        <CouncilCalendarInfoModal
          calendar={calendar}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
    </div>
  );
}

export default CouncilCalendarCard;
